import React, { useMemo } from 'react';
import { View, Text, useWindowDimensions } from 'react-native';
import { PickCell } from './PickCell';
import type { ChallengeCardStyles } from '../../src/challenges/styles/challengeCard.styles';
import { WIDE_LAYOUT_MIN_WIDTH, type MatchBetPickSlotProps } from './MatchBetThreeColumnGrid';

export interface MatchBetThreeColumnMarketRowProps {
  styles: ChallengeCardStyles;
  marketNameText: string;
  myPick: MatchBetPickSlotProps;
  opponentPick: MatchBetPickSlotProps;
  /** Optional content below market name (e.g. CorrectOutcomeRow) */
  centerFooter?: React.ReactNode;
}

export const MatchBetThreeColumnMarketRow: React.FC<MatchBetThreeColumnMarketRowProps> = ({
  styles,
  marketNameText,
  myPick,
  opponentPick,
  centerFooter,
}) => {
  const { width: screenWidth } = useWindowDimensions();
  const useWideLayout = screenWidth >= WIDE_LAYOUT_MIN_WIDTH;
  const pickCellContainerStyle = useWideLayout ? styles.pickCellWide : undefined;

  const colSideStyle = useMemo(
    () => [
      styles.matchBetCol,
      styles.matchBetColSide,
      useWideLayout && styles.matchBetColSideWide,
    ],
    [styles, useWideLayout]
  );

  return (
    <View style={styles.betRow}>
      <View style={colSideStyle}>
        <PickCell
          label={myPick.label}
          odds={myPick.odds}
          isCorrect={myPick.isCorrect}
          isWrong={myPick.isWrong ?? false}
          containerStyle={pickCellContainerStyle}
          onPress={myPick.onPress}
          testID={myPick.testID}
        />
      </View>
      <View style={[styles.matchBetCol, styles.matchBetColCenter, styles.betRowMarketName]}>
        <Text style={styles.betRowMarketNameText} numberOfLines={2}>
          {marketNameText}
        </Text>
        {centerFooter}
      </View>
      <View style={colSideStyle}>
        <PickCell
          label={opponentPick.label}
          odds={opponentPick.odds}
          isCorrect={opponentPick.isCorrect}
          isWrong={opponentPick.isWrong ?? false}
          containerStyle={pickCellContainerStyle}
          testID={opponentPick.testID}
        />
      </View>
    </View>
  );
};
